import React, { useState } from 'react'
import styled from 'styled-components'

import { useI18n } from 'core/i18n/i18nContext'
import { spacing } from 'core/theme'

const baseMailApiAddress = 'https://stateofreactnative.com'

export default function Newsletter({ locale }) {
    const [state, setState] = useState(undefined) // 'pending' | 'success' | 'failed'

    const [email, setEmail] = useState('')

    const handleChange = e => {
        const email = e.target.value
        setEmail(email)
    }

    const handleSubmit = async e => {
        setState('pending')

        e.preventDefault()

        const { status } = await fetch(`${baseMailApiAddress}/api/newsletter-subscribe`, {
            method: 'POST',
            body: JSON.stringify({ email })
        })

        if (status === 200) {
            setState('success')
            return
        }

        setState('failed')
    }

    const clearForm = () => {
        setEmail('')
        setState(undefined)
    }

    return (
        <div className="newsletter">
            {(!state || state === 'pending') && (
                <NewsletterForm
                    email={email}
                    loading={false}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    locale={locale}
                />
            )}
            {state === 'failed' && (
                <Error>
                    <h4>Something went wrong!</h4>
                    <ErrorWrapper>
                        <p>
                            You might have already subscribed using this address. In this case,
                            please check your mailbox and confirm your subscription.
                        </p>
                        <Button onClick={clearForm}>Retry</Button>
                    </ErrorWrapper>
                </Error>
            )}
            {state === 'success' && (
                <Success>
                    <h4>Confirm your e-mail address</h4>
                    <p>Check your inbox to confirm your newsletter subscription.</p>
                </Success>
            )}
        </div>
    )
}

const NewsletterForm = ({ email, handleSubmit, handleChange }) => {
    const { getString } = useI18n()

    return (
        <Form method="post" onSubmit={handleSubmit}>
            <Input
                id="field_0"
                name="field_0"
                type="email"
                placeholder="Your E-mail Address"
                onChange={handleChange}
                value={email}
            />
            <input type="text" tabIndex={-1} autoComplete="nope" style={{ display: 'none' }} />
            <Button type="submit" name="subscribe">
                Sign up!
            </Button>
        </Form>
    )
}

const Form = styled.form`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #c2c7e4;
    background-color: white;
    padding: ${spacing(0.5)};
`
const Input = styled.input`
    background: none;
    border: none;
    color: #001a72;
    width: 100%;

    &:focus {
        outline: none;
    }

    &::placeholder {
        color: var(--primary-color-20);
    }
`
const Button = styled.button`
    background-color: #001a72;
    color: white;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    padding: ${spacing(0.5)} ${spacing(1)};
    height: auto;
    outline: none;
    border: none;
    white-space: nowrap;

    &:hover {
        opacity: 0.8;
    }

    &:active {
        opacity: 0.6;
    }
`

const Success = styled.div`
    background-color: #b1dfd0;
    padding: ${spacing()};
`

const Error = styled.div`
    background-color: #ffa3a1;
    padding: ${spacing()};
`

const ErrorWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
`
